import React from 'react'

export default function NoMatch() {
    return (
        <div>
            <h1>404</h1>
        </div>
    )
}
